import axiosInstance from "@/api/axios"
import safeJsonParse from "@/utils/safeParse"
import { safeLocalStorage, safeSessionStorage } from "@/utils/safeStorage"

export const setWindowTitle = (webSiteDisplayName: string) => {
  window.document.title = webSiteDisplayName
}

const removeQueryPassFromUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("queryPass")
  window.history.replaceState({}, document.title, url.toString())
}

const removeCertificationFromUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("termsVersion")
  url.searchParams.delete("resetPassword")
  window.history.replaceState({}, document.title, url.toString())
}

export const setQueryPass = (): boolean => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)
  const queryPassMatch = url.hash.match(/queryPass=([^&]*)/)
  const queryPassValue = queryPassMatch ? queryPassMatch[1] : null
  const queryPass = queryPassValue || url.searchParams.get("queryPass")

  if (!queryPass) return false
  axiosInstance.defaults.headers.common.Authorization = queryPass
  // 暫存 URL 帶進來的 queryPass 值給 App.vue 做 tracking session 辨識
  safeSessionStorage.setItem("urlQueryPass", queryPass)
  removeQueryPassFromUrl()
  return true
}

export const setCertification = () => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)

  // 當已經透過 vue-router 轉址後，會將參數放在 hash 裡面
  const termsVersionMatch = url.hash.match(/termsVersion=([^&]*)/)
  const resetPasswordMatch = url.hash.match(/resetPassword=([^&]*)/)
  const eventTypeMatch = url.hash.match(/eventType=([^&]*)/)

  const termsVersionValue = termsVersionMatch ? termsVersionMatch[1] : null
  const resetPasswordValue = resetPasswordMatch ? resetPasswordMatch[1] : null
  const eventTypeValue = eventTypeMatch ? eventTypeMatch[1] : null

  // 未透過 vue-router 轉址，參數會放在 url 裡面
  const termsVersion = termsVersionValue || url.searchParams.get("termsVersion")
  const resetPassword = resetPasswordValue || url.searchParams.get("resetPassword")
  const eventType = eventTypeValue || url.searchParams.get("eventType")

  if (!termsVersion && !resetPassword) return

  const parsedTermsVersion = termsVersion ? safeJsonParse<number[]>(termsVersion, []) : []
  const parsedResetPassword = resetPassword === "true"

  const certification: {
    termsVersion: number[]
    resetPassword: boolean
    eventType?: number
  } = {
    termsVersion: parsedTermsVersion,
    resetPassword: parsedResetPassword
  }

  if (eventType) {
    certification.eventType = Number.parseInt(eventType, 10)
  }

  safeLocalStorage.setItem("certification", JSON.stringify(certification))

  removeCertificationFromUrl()
}
